export const ACTIVE_AGREEMENTS = 'activeAgreements';

export const ACTIVE_AGREEMENTS_ACTIONS_NAME = {
  searchAgreements: `${ACTIVE_AGREEMENTS}/searchAgreements`,
  getAgreementsCount: `${ACTIVE_AGREEMENTS}/getAgreementsCount`,
  getAgreementTypes: `${ACTIVE_AGREEMENTS}/getAgreementTypes`,
};

export const ACTIVE_AGREEMENTS_MUTATIONS_NAME = {
  setListOfAgreements: `${ACTIVE_AGREEMENTS}/setListOfAgreements`,
  setAgreementsCount: `${ACTIVE_AGREEMENTS}/setAgreementsCount`,
  setIsLoadingCount: `${ACTIVE_AGREEMENTS}/setIsLoadingCount`,
  setAgreementTypes: `${ACTIVE_AGREEMENTS}/setAgreementTypes`,
};

export const ACTIVE_AGREEMENTS_GETTERS_NAME = {
  getListOfAgreements: `${ACTIVE_AGREEMENTS}/getListOfAgreements`,
  getAgreementsCount: `${ACTIVE_AGREEMENTS}/getAgreementsCount`,
  getIsLoadingCount: `${ACTIVE_AGREEMENTS}/getIsLoadingCount`,
  getAgreementTypes: `${ACTIVE_AGREEMENTS}/getAgreementTypes`,
};
